module.exports = __webpack_public_path__ + "media/images/marker-icon-0f5b873225db86e9b41aee517a5ec0d7.png";